import SupportFeedbackPage from './SupportFeedback'

const SupportFeedbackPageRouter = () => {
  return <SupportFeedbackPage />
}

export default SupportFeedbackPageRouter
